import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { ArrowUpRight } from "lucide-react";

const Footer = () => {
  const { SOCIAL, BRAND } = useContent();
  const location = useLocation();
  const hideCTA = location.pathname === "/contact";
  const isContact = location.pathname === "/contact";

  return (
    <footer
      className="bg-canvas text-ink border-t border-ink/10"
      data-testid="site-footer"
    >
      <div className="mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-start">
          {/* Left: heading + CTA */}
          <div className="md:col-span-8" data-testid="footer-cta">
            {!hideCTA && (
              <>
                <h2 className="font-heading font-black leading-[1.05] tracking-[-0.02em] text-[22px] md:text-[34px] uppercase">
                  Let’s craft your{" "}
                  <span className="italic font-serif font-normal text-ink/70 normal-case">
                    idea.
                  </span>
                </h2>
                <Link
                  to="/contact"
                  data-testid="footer-start-project"
                  className="mt-6 inline-flex items-center gap-3 group"
                >
                  <span className="text-[11px] uppercase tracking-[0.3em]">
                    Get in touch
                  </span>
                  <span className="w-9 h-9 rounded-full border border-ink flex items-center justify-center transition-transform duration-500 group-hover:rotate-45 group-hover:bg-ink group-hover:text-canvas">
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
              </>
            )}
          </div>

          {/* Right: Socials only, matched size + pushed right */}
          <div className="md:col-span-4 md:pt-2 md:text-right" data-testid="footer-socials-block">
            <p className="text-[11px] tracking-[0.3em] uppercase text-ink/80 mb-4">
              Socials
            </p>
            <ul
              className="flex flex-wrap md:justify-end items-center gap-x-6 gap-y-3"
              data-testid="footer-social-list"
            >
              {SOCIAL.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="text-ink/80 hover:text-ink inline-flex items-center gap-1 transition-colors text-[11px] uppercase tracking-[0.3em]"
                  >
                    {s.label}
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact-page-only tail: studio + locations */}
        {isContact && (
          <div
            className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
            data-testid="footer-contact-tail"
          >
            <p className="text-[11px] tracking-[0.28em] uppercase text-ink/70">
              Studio · {BRAND.email}
            </p>
            <p className="text-[11px] tracking-[0.28em] uppercase text-ink/70">
              {BRAND.locations
                .split(/\s+/)
                .join(" ")
                .replace(/·/g, "·")}
            </p>
          </div>
        )}

        {/* Divider before copyright */}
        <div className="mt-10 border-t border-ink/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[10px] tracking-[0.28em] uppercase text-ink/40">
            {BRAND.copyright}
          </p>
          <p className="text-[10px] tracking-[0.28em] uppercase text-ink/40">
            {BRAND.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
